(function () {
  var PLATFORMS_HASH = '#section_platforms';

  function getNavScrollOffset(nav) {
    if (!nav) {
      return 0;
    }

    var rect = nav.getBoundingClientRect();
    var styles = window.getComputedStyle(nav);

    if (styles.position === 'fixed' || styles.position === 'sticky') {
      return rect.bottom;
    }

    return 0;
  }

  function scrollToPlatformsSection(nav, target, behavior) {
    if (!target) {
      return;
    }

    var scrollBehavior = behavior || 'smooth';
    var navOffset = getNavScrollOffset(nav);
    var top = target.getBoundingClientRect().top + window.scrollY - navOffset;

    window.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior });
  }

  function scrollToPlatformsWithCorrection(nav, target) {
    var QUIET_MS = 300;
    var MAX_MS = 3000;
    var DEBOUNCE_MS = 80;
    var startedAt = Date.now();
    var quietTimer = null;
    var maxTimer = null;
    var resizeObserver = null;
    var debounceTimer = null;

    var correct = function () {
      scrollToPlatformsSection(nav, target, 'instant');
    };

    var scheduleCorrect = function () {
      if (debounceTimer) {
        window.clearTimeout(debounceTimer);
      }
      debounceTimer = window.setTimeout(correct, DEBOUNCE_MS);
    };

    var stopWatching = function () {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (quietTimer) {
        window.clearTimeout(quietTimer);
        quietTimer = null;
      }
      if (maxTimer) {
        window.clearTimeout(maxTimer);
        maxTimer = null;
      }
      if (debounceTimer) {
        window.clearTimeout(debounceTimer);
        debounceTimer = null;
      }
    };

    var bumpQuiet = function () {
      if (quietTimer) {
        window.clearTimeout(quietTimer);
      }
      quietTimer = window.setTimeout(stopWatching, QUIET_MS);
    };

    var watchLayout = function () {
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      var observed = document.documentElement;
      resizeObserver = new ResizeObserver(function () {
        if (Date.now() - startedAt > MAX_MS) {
          stopWatching();
          return;
        }
        scheduleCorrect();
        bumpQuiet();
      });
      resizeObserver.observe(observed);
      bumpQuiet();
    };

    scrollToPlatformsSection(nav, target, 'smooth');
    watchLayout();

    if ('onscrollend' in window) {
      window.addEventListener(
        'scrollend',
        function () {
          correct();
          bumpQuiet();
        },
        { once: true }
      );
    }

    window.setTimeout(correct, 400);
    window.setTimeout(correct, 1000);
    maxTimer = window.setTimeout(stopWatching, MAX_MS);
  }

  function initPlatformsAnchorScroll(root, nav, beforeScroll) {
    var scrollFromHash = function () {
      if (window.location.hash !== PLATFORMS_HASH) {
        return;
      }

      var target = document.getElementById('section_platforms');
      if (!target) {
        return;
      }

      window.requestAnimationFrame(function () {
        if (beforeScroll) {
          beforeScroll();
        }
        scrollToPlatformsWithCorrection(nav, target);
      });
    };

    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="' + PLATFORMS_HASH + '"], a[href*="' + PLATFORMS_HASH + '"]');
      if (!link || link.target === '_blank') {
        return;
      }

      if (link.hash !== PLATFORMS_HASH) {
        return;
      }

      var target = document.getElementById('section_platforms');
      if (!target) {
        return;
      }

      var linkPath = link.pathname || window.location.pathname;
      if (linkPath !== window.location.pathname) {
        return;
      }

      e.preventDefault();
      if (beforeScroll) {
        beforeScroll();
      }
      scrollToPlatformsWithCorrection(nav, target);
    });

    scrollFromHash();
    window.addEventListener('hashchange', scrollFromHash);
    window.addEventListener('pageshow', scrollFromHash);
  }

  function initBusyAppNav(root) {
    const nav = root.querySelector('nav.nav');
    if (!nav) {
      return;
    }

    const ddRoot = root.querySelector('.platform_dropdown.w-dropdown');
    const ddToggle = root.querySelector('.platform_dropdown-toggle.w-dropdown-toggle');
    const ddList = root.querySelector('.platform_list.w-dropdown-list');

    const closeDropdown = function () {
      if (!ddRoot || !ddToggle || !ddList) {
        return;
      }
      ddRoot.classList.remove('w--open');
      ddToggle.classList.remove('w--open');
      ddList.classList.remove('w--open');
      ddToggle.setAttribute('aria-expanded', 'false');
    };

    if (ddRoot && ddToggle && ddList) {
      ddToggle.setAttribute('aria-haspopup', 'true');
      ddToggle.setAttribute('aria-expanded', 'false');
      ddToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (ddRoot.classList.contains('w--open')) {
          closeDropdown();
        } else {
          ddRoot.classList.add('w--open');
          ddToggle.classList.add('w--open');
          ddList.classList.add('w--open');
          ddToggle.setAttribute('aria-expanded', 'true');
        }
      });
    }

    const menuBtn = nav.querySelector('.nav_menu-button');
    const menuWrap = nav.querySelector('.nav_menu-wrap');
    const sectionSuffix = root.getAttribute('data-busy-app-section-id') || '';

    const closeMobileMenu = function () {
      nav.classList.remove('busy-app-menu-is-open');
      document.body.classList.remove('busy-app-mobile-nav-open');
      document.body.style.overflow = '';
      if (menuBtn) {
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.setAttribute('aria-label', 'Open menu');
      }
    };

    if (menuBtn && menuWrap) {
      if (!menuWrap.id) {
        menuWrap.id = 'busy-app-nav-panel-' + sectionSuffix;
      }
      menuBtn.setAttribute('aria-expanded', 'false');
      menuBtn.setAttribute('aria-controls', menuWrap.id);
      menuBtn.setAttribute('aria-label', 'Open menu');
      menuBtn.setAttribute('role', 'button');
      menuBtn.tabIndex = 0;

      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const open = !nav.classList.contains('busy-app-menu-is-open');
        nav.classList.toggle('busy-app-menu-is-open', open);
        if (open) {
          document.body.classList.add('busy-app-mobile-nav-open');
          document.body.style.overflow = 'hidden';
        } else {
          closeMobileMenu();
        }
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });

      menuBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          menuBtn.click();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (ddRoot && ddRoot.classList.contains('w--open') && !ddRoot.contains(e.target)) {
        closeDropdown();
      }
      if (nav.classList.contains('busy-app-menu-is-open') && !nav.contains(e.target)) {
        closeMobileMenu();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') {
        return;
      }
      closeDropdown();
      closeMobileMenu();
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 767px)').matches) {
        closeMobileMenu();
      }
    });

    var lastScrollY = window.scrollY;
    var desktopQuery = window.matchMedia('(min-width: 767px)');

    function updateNavScrollState() {
      if (nav.classList.contains('busy-app-menu-is-open')) {
        return;
      }
      var currentY = window.scrollY;
      if (desktopQuery.matches) {
        nav.classList.toggle('nav--scrolled', currentY > 60);
      } else {
        nav.classList.remove('nav--scrolled');
      }
      if (currentY > lastScrollY && currentY > 60) {
        nav.classList.add('nav--hidden');
      } else {
        nav.classList.remove('nav--hidden');
      }
      lastScrollY = currentY;
    }

    updateNavScrollState();
    window.addEventListener('scroll', updateNavScrollState, { passive: true });

    initPlatformsAnchorScroll(root, nav, function () {
      closeDropdown();
      closeMobileMenu();
      nav.classList.remove('nav--hidden');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-busy-app-nav]').forEach(initBusyAppNav);
  });
})();
